import { Search } from '@features/ForestOwner/Search/SearchPage/Search'
import { forestOwnerSearchSchema } from '@services/queryOptions.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/search/')({
  loaderDeps: ({ search }) => search,
  validateSearch: forestOwnerSearchSchema,
  component: Search,
  staticData: {
    breadcrumb: 'Søk',
  },
})
